import { ButtonBase } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { Tables } from '../../../../../Components';
import { filterData, headerData } from './headerData';
import { useTranslation } from 'react-i18next';
import { TableActions, TableFilterTypesEnum } from '../../../../../Enums';
import { isEqual } from 'lodash';
import OfferManagementDialog from './components/OfferManagementDialog/OfferManagementDialog';
import { GetFilteredVendorOffers } from '../../../../../Services';
import { GetParams, returnPropsByPermissions, showError } from '../../../../../Helper';
import DeleteOfferDialog from './components/DeleteOfferDialog';
import { VendorsTranslationPath } from '../../I18n/VendorsLocale';
import ExportButton from './components/ExportButton';
import { OffersPermissions  } from '../../../../../Permissions' ; 

const Offers = ({ parentTranslationPath }) => {
  parentTranslationPath = parentTranslationPath ?? VendorsTranslationPath;
  const { t } = useTranslation(parentTranslationPath);
  const [data, setData] = useState({ result: [], totalCount: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const vendorId = GetParams('id') ? +GetParams('id') : null;
  const [activeItem, setActiveItem] = useState(null);
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 25,
    vendorId,
  });

  const [managementDialogOpen, setManagementDialogOpen] = useState(false);
  const [deleteOfferDialogOpen, setDeleteOfferDialogOpen] = useState(false);

  const onFilterValuesChanged = (filterValue) => {
    if (filterValue && !!Object.values(filterValue).length) {
      const { value, searchableKey } = Object.values(filterValue)[0];
      setFilter((filter) => ({
        ...filter,
        [searchableKey]: value,
      }));
    } else {
      const updatedFilter = Object.fromEntries(
        Object.entries(filter).filter(([_key, value]) => !!value || value === 0)
      );
      if (!isEqual(updatedFilter, filter)) {
        setFilter(updatedFilter);
      }
    }
  };
  const getFilteredVendorOffers = useCallback(async () => {
    if (returnPropsByPermissions(OffersPermissions.ViewOffers.permissionsId)) {
      try {
        setIsLoading(true);
        const res = await GetFilteredVendorOffers(filter);
        setData(res);
      } catch (error) {
        showError(t("something_went_wrong"));
      } finally {
        setIsLoading(false);
      }
    }
  }, [filter]);

  const reload = (filterData = {}) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageIndex: 0,
      ...filterData,
    }));
  };
  useEffect(() => {
    getFilteredVendorOffers();
  }, [getFilteredVendorOffers]);

  return (
    <div className='p-3 flex d-flex-column gap-1'>
      <div className='flex fj-between fa-center'>
        <ButtonBase
          className='btns theme-solid px-3'
          onClick={() => setManagementDialogOpen(true)}
        >
          <span className='mdi mdi-plus' />
          {t(`add_offer`)}
        </ButtonBase>
        <ExportButton
          filter={{ ...filter, pageSize: data.totalCount, pageIndex: 0 , totalCount :data.totalCount  }}
        />
      </div>
      <div className='flex fj-center'></div>
      <Tables
        data={data.result}
        headerData={headerData(t, getFilteredVendorOffers)}
        totalItems={data.totalCount}
        parentTranslationPath={parentTranslationPath}
        isLoading={isLoading}
        onPageIndexChanged={(pageIndex) =>
          setFilter({ ...filter, pageIndex: pageIndex + 1 })
        }
        isWithFilter
        filterData={filterData(t, reload).map((item) => ({
          ...item,
          key: item.input,
          filterType: item.filterType ?? TableFilterTypesEnum.textInput.key,
          searchableKey: item.searchableKey ?? item.input,
        }))}
        onPageSizeChanged={(pageSize) => setFilter({ ...filter, pageSize })}
        onFilterValuesChanged={onFilterValuesChanged}
        FilterDisabledButton
        itemsPerPage={filter.pageSize}
        activePage={filter.pageIndex}
        defaultActions={[
          { enum: TableActions.delete.key },
          { enum: TableActions.edit.key },
        ]}
        setSortBy={(data) =>
          setFilter((preFilter) => ({ ...preFilter, ...data }))
        }
        actionsOptions={{
          onActionClicked: (actionEnum, item) => {
            setActiveItem(item);
            if (actionEnum === TableActions.edit.key) {
              setManagementDialogOpen(true);
            } else if (actionEnum === TableActions.delete.key) {
              setDeleteOfferDialogOpen(true);
            }
          },
        }}
      />
      {managementDialogOpen && (
        <OfferManagementDialog
          open
          onClose={() => {
            setManagementDialogOpen(false);
            setActiveItem(null);
          }}
          parentTranslationPath={parentTranslationPath}
          reload={reload}
          activeItem={activeItem}
        />
      )}
      {deleteOfferDialogOpen && (
        <DeleteOfferDialog
          activeItem={activeItem}
          open
          onClose={() => {
            setDeleteOfferDialogOpen(false);
            setActiveItem(null);
          }}
          reload={reload}
        />
      )}
    </div>
  );
};
export default Offers;
